import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import parse from 'html-react-parser';

import { api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);

    const bets_risks_list = useRef(null)
    const bets_risks_list_active = useRef(null)
 
    const year_active = useRef(null);
    const years_actives = useRef(null);
    const type_active = useRef(null);
    const types_actives = useRef(null);

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const get_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(async res => {
                if (res.data[0] !== undefined) {
                    setData(res.data)

                    let i = 0
                    let j = 0
                    let bets_risks_aux = []
                    let array_type_aux = []
                    let array_ano_aux = []
                    if(Array.isArray(res.data)) {
                        for await (let el of res.data) {

                            if(Array.isArray(el.info.action)) {
                                for await (let el_2 of el.info.action) {
                                    if(parseInt(el_2.strategy_type) === 37) {
                                        el_2.number = 'APOSTA ' + (++i)
                                        el_2.id_parent = el.id
                                        el_2.year = el.info.tag
                                        bets_risks_aux.push(el_2)
                                    }
                                    if(parseInt(el_2.strategy_type) === 38) {
                                        el_2.number = 'RISCO ' + (++j)
                                        el_2.id_parent = el.id
                                        el_2.year = el.info.tag
                                        bets_risks_aux.push(el_2)
                                    }

                                    let aux_1 = array_type_aux.filter(e1 => parseInt(e1) === parseInt(el_2.strategy_type))
                                    if(Array.isArray(aux_1) && aux_1.length === 0) {
                                        array_type_aux.push(el_2.strategy_type)
                                    }
                                    let aux_2 = array_ano_aux.filter(e1 => parseInt(e1) === parseInt(el.info.tag))
                                    if(Array.isArray(aux_2) && aux_2.length === 0) {
                                        array_ano_aux.push(el.info.tag)
                                    }
                                }
                            }
                        }
                    }
                    set_dados(bets_risks_list.current = bets_risks_aux)
                    setData(bets_risks_aux)

                    set_dados(types_actives.current = array_type_aux)
                    set_dados(type_active.current = 0)

                    set_dados(years_actives.current = array_ano_aux)
                    set_dados(year_active.current = years_actives.current[0])

                    change_year(years_actives.current[0])

                }
            })
            .catch(() => 404
            )
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    const get_state = (id) => {

        let result = ''
        if(parseInt(id) === parseInt(48)) {
            result = '<span className="px-2 py-1 bg-orange">A iníciar</span>'
        }
        else if(parseInt(id) === parseInt(49)) {
            result = '<span className="px-2 py-1 bg-primary text-white">On going</span>'
        }
        else if(parseInt(id) === parseInt(50)) {
            result = '<span className="px-2 py-1 bg-success text-white">Concluída</span>'
        }
        else if(parseInt(id) === parseInt(51)) {
            result = '<span className="px-2 py-1 bg-danger">Desistida</span>'
        }

        return result

    }

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const columns = [
        {
            name: 'Ano',
            selector: 'year',
            width: '5% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: 'Aposta / Risco',
            selector: 'number',
            width: '8% !important',
            minWidth: '100px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_description,
            selector: 'description',
            cell: row => (
                <div className="text-start">
                    {row.description}
                </div>
            ),
            width: '15% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_actions,
            selector: 'actions',
            cell: row => (
                <div className="text-start align-middle col-12">
                    {
                    row?.action !== undefined ?
                        row.action.map((a_el, a_key) => {
                            return (
                                <div key={a_key} className={"row py-2 border-start border-end" + (a_key < row.action.length - 1 ? ' border-bottom' : '')}>
                                    <div className="text-start align-middle" style={{width: '8%', minWidth: '70px'}}>
                                        Ação {a_key + 1}
                                    </div>
                                    <div className="text-start align-middle" style={{width: '40%'}}>
                                        {a_el.description}
                                    </div>
                                    <div className="text-start align-middle" style={{width: '8%', minWidth: '70px'}}>
                                        <span>
                                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id_parent, id_row: a_el.id, element: row }, operation: 'edit' } }} style={{ display: '' }} replace>
                                                <i className="bi bi-pencil"></i>
                                            </Link>
                                        </span>
                                    </div>
                                    <div className="text-start align-middle" style={{width: '42%'}}>
                                        {
                                        a_el.followup !== undefined && a_el.followup !== null ?
                                            a_el.followup.map((follow_el, follow_key) => {
                                                if(follow_key === a_el.followup.length - 1) {
                                                    return (
                                                        <div key={follow_key} className="row">
                                                            <div className="col-4 text-center">
                                                                <span style={{
                                                                    fontFamily: 'monospace',
                                                                    fontVariantNumeric: 'tabular-nums',
                                                                }}>
                                                                    {follow_el.date}
                                                                </span>
                                                            </div>
                                                            <div className="col-4 text-center">
                                                                {parse(get_state(follow_el.state))}
                                                            </div>
                                                            <div className="col-4 text-center">
                                                                <span style={{
                                                                    fontFamily: 'monospace',
                                                                    fontVariantNumeric: 'tabular-nums',
                                                                }}>
                                                                    {follow_el.date}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                else {
                                                    return null
                                                }
                                            })
                                        :
                                            null
                                        }
                                    </div>
                                </div>
                            )
                        })
                    :
                        null
                    }
                </div>
            ),
            width: '72% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        }
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: bets_risks_list_active.current !== undefined && bets_risks_list_active.current !== null ? bets_risks_list_active.current : [],
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    const get_type_name = (id) => {

        let result = ''
        if(parseInt(id) === 37) {
            result = 'Apostas'
        }
        if(parseInt(id) === 38) {
            result = 'Riscos'
        }
        return result
    }

    const change_type = (id) => {

        if(parseInt(id) === 0) {
            set_dados(type_active.current = id)
            let aux = bets_risks_list.current.filter(e => (e?.year !== undefined && parseInt(e.year) === parseInt(year_active.current)))
            set_dados(bets_risks_list_active.current = aux)   
        }
        else {
            set_dados(type_active.current = id)
            let aux = bets_risks_list.current.filter(e => (parseInt(e.strategy_type) === parseInt(id) && e?.year !== undefined && parseInt(e.year) === parseInt(year_active.current)))
            set_dados(bets_risks_list_active.current = aux)   

        }

    }

    const order_array = (array, type) => {

        return array.sort((a, b) => {
			const nameA = a[type].toUpperCase(); // ignore upper and lowercase
			const nameB = b[type].toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

	}


    const change_year = async (id) => {

        if(parseInt(type_active.current) === 0) {
            set_dados(year_active.current = id)

            let aux = bets_risks_list.current.filter(e => parseInt(e.year) === parseInt(id))
            set_dados(bets_risks_list_active.current = aux)
        }
        else {
            set_dados(year_active.current = id)
            
            let aux = bets_risks_list.current.filter(e => (parseInt(e.year) === parseInt(id) && parseInt(e.strategy_type) === parseInt(type_active.current)))
            set_dados(bets_risks_list_active.current = aux)

        }

    }


    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container-fluid">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                    </div>
                                    <div className="table-body table-responsive">
                                        {
                                        years_actives.current !== undefined && years_actives.current !== null && Array.isArray(years_actives.current) && years_actives.current.length > 0 ?
                                            <div className="row">
                                                <div className="col-10 mb-3 d-flex">
                                                    {
                                                    years_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el) === parseInt(year_active.current) ? ' active' : '' )} onClick={() => change_year(dt_el)} >{parseInt(dt_el)}</button>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        :
                                            null
                                        }
                                        {
                                        types_actives.current !== undefined && types_actives.current !== null && Array.isArray(types_actives.current) && types_actives.current.length > 0 ?
                                            <div className="row">
                                                <div className="col-12 mb-3 d-flex">
                                                    <div>
                                                        <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(type_active.current) === 0 ? ' active' : '') } onClick={() => change_type(0)} >{language[lang].table_all}</button>
                                                    </div>
                                                    {
                                                    types_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el) === parseInt(type_active.current) ? ' active' : '') } onClick={() => change_type(dt_el)} >{get_type_name(dt_el)}</button>
                                                            </div>
                                                        )
                                                    })
                                                    }
                                                </div>
                                            </div>
                                        :
                                            null
                                        }
                                        <div className="row d-none">
                                            <div className="col-12">

                                                <DataTableExtensions {...tableData}>
                                                    <DataTable
                                                        noDataComponent={language[lang].table_empty}
                                                        noHeader
                                                        defaultSortField="number"
                                                        defaultSortAsc={true}
                                                        pagination
                                                        exportHeaders
                                                        paginationComponentOptions={defaultComponentOptions}
                                                        paginationPerPage={25}
                                                        paginationRowsPerPageOptions={[25, 50, 100]}
                                                    />
                                                </DataTableExtensions>

                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">

                                                <table className="table betsrisks-list table-hover table-bordered align-middle">
                                                    <thead className="text-center align-middle">
                                                        <tr>
                                                            <th rowSpan={2} className="text-uppercase p-3">
                                                                Ano
                                                            </th>
                                                            <th rowSpan={2} className="p-3">{language[lang].field_type}</th>
                                                            <th rowSpan={2} className="p-3">{language[lang].field_designation}</th>
                                                            <th rowSpan={2} colSpan={3} className="p-3">{language[lang].field_actions}</th>
                                                            <th colSpan={3} className="p-3">{language[lang].field_followup}</th>
                                                            <th colSpan={2} className="p-3">{language[lang].field_case_completed}</th>
                                                            <th colSpan={2} className="p-3">{language[lang].field_case_not_completed}</th>
                                                        </tr>
                                                        <tr>
                                                            <th className="p-3">
                                                                {language[lang].field_action_deadline_actual}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_state}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_last_update}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_goal_accomplished}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_effective_action}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_action_matter}
                                                            </th>
                                                            <th className="p-3">
                                                                {language[lang].field_next_year}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                        bets_risks_list_active.current !== undefined && bets_risks_list_active.current !== null && Array.isArray(bets_risks_list_active.current) && bets_risks_list_active.current.length > 0 ?
                                                            bets_risks_list_active.current.map((el_br, key_br) => {
                                                                return (
                                                                    <>
                                                                    <tr key={key_br}>   
                                                                        <td rowSpan={Array.isArray(el_br.action) && el_br.action.length + 1}>
                                                                            {el_br.year}
                                                                        </td>
                                                                        <td rowSpan={Array.isArray(el_br.action) && el_br.action.length + 1}>
                                                                            <div className="text-nowrap">{el_br.number}</div>
                                                                        </td>
                                                                        <td rowSpan={Array.isArray(el_br.action) && el_br.action.length + 1}>
                                                                            {el_br.description}
                                                                        </td>
                                                                    </tr>
                                                                    {
                                                                    Array.isArray(el_br.action) && el_br.action.length > 0 ?
                                                                        el_br.action.map((el_br_a, k_br_a) => {
                                                                            return (
                                                                                <tr key={k_br_a}>
                                                                                    <td><div className="text-nowrap">Ação {el_br_a.number}</div></td>
                                                                                    <td>{el_br_a.description}</td>
                                                                                    <td>
                                                                                        <span>
                                                                                            <Link className="button button-update p-0" to={{ pathname: endpoints.regist, state: { item: { id: el_br.id_parent, id_row: el_br_a.id, element: el_br }, operation: 'edit' } }} style={{ display: '' }} replace>
                                                                                                <i className="bi bi-pencil"></i>
                                                                                            </Link>
                                                                                        </span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-nowrap text-nowrap text-center">
                                                                                            <span style={{
                                                                                                fontFamily: 'monospace',
                                                                                                fontVariantNumeric: 'tabular-nums',
                                                                                            }}>
                                                                                                {el_br_a.deadline_initial}
                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-nowrap text-nowrap text-center">
                                                                                            {
                                                                                            el_br_a.followup !== undefined && el_br_a.followup.length > 0 ?
                                                                                                parse(get_state(el_br_a.followup[el_br_a.followup.length - 1].state))
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-nowrap text-nowrap text-center">
                                                                                            {
                                                                                            el_br_a.followup !== undefined && el_br_a.followup.length > 0 ?
                                                                                                <span style={{
                                                                                                    fontFamily: 'monospace',
                                                                                                    fontVariantNumeric: 'tabular-nums',
                                                                                                }}>
                                                                                                    {el_br_a.followup[el_br_a.followup.length - 1].date}
                                                                                                </span>
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-center">
                                                                                            {
                                                                                            parseInt(el_br_a.state) === 1 ?
                                                                                                parseInt(el_br_a.goal_state) === 1 ? 'Sim' : 'Não'
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-center">
                                                                                            {
                                                                                            parseInt(el_br_a.state) === 1 ?
                                                                                                parseInt(el_br_a.effective) === 1 ? 'Sim' : 'Não'
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-center">
                                                                                            {
                                                                                            parseInt(el_br_a.state) === 0 ?
                                                                                                parseInt(el_br_a.interest) === 1 ? 'Sim' : 'Não'
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="text-center">
                                                                                            {
                                                                                            parseInt(el_br_a.state) === 0 ?
                                                                                                parseInt(el_br_a.next_year) === 1 ? 'Sim' : 'Não'
                                                                                            :
                                                                                                null
                                                                                            }
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                    :
                                                                        null
                                                                    }
                                                                    </>
                                                                )

                                                            })
                                                        :
                                                            null
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}